import React from "react";
import Router from "./routes/Routes";
import withClearCache from "./hoc/WithClearCache";
import { Toaster } from "react-hot-toast";
import WithAuthentication from "../src/Authentication/WithAuthentication";
import { Tooltip } from "react-tooltip";
import { SearchInputProvider } from "./Search/SearchInput";
import { UseFullDataProvider } from "./context/UseFullData";
const ClearCacheComponent = withClearCache(MainApp);
function App() {
  return <ClearCacheComponent />;
}

function MainApp() {
  return (
    <div className="App">
      <Tooltip>
        <Toaster />
        <WithAuthentication>
          <UseFullDataProvider>
            <SearchInputProvider>
              <Router />
            </SearchInputProvider>
          </UseFullDataProvider>
        </WithAuthentication>
      </Tooltip>
    </div>
  );
}
export default App;
